export default "/images/62c76fec6bee7c00c4ef23745cce9507.avif";